/**
 * 商铺管理 Store 模块
 */

const shopStore = {
  namespaced: true,
  
  state: {
    shops: {},
    currentShopId: null,
    isLoading: false
  },

  mutations: {
    SET_SHOPS(state, shops) {
      state.shops = shops
    },
    SET_CURRENT_SHOP(state, shopId) {
      state.currentShopId = shopId
    },
    ADD_SHOP(state, { shopId, config }) {
      state.shops = {
        ...state.shops,
        [shopId]: config
      }
    },
    UPDATE_SHOP(state, { shopId, config }) {
      if (state.shops[shopId]) {
        state.shops[shopId] = {
          ...state.shops[shopId],
          ...config,
          updatedAt: new Date().toISOString()
        }
      }
    },
    DELETE_SHOP(state, shopId) {
      const shops = { ...state.shops }
      delete shops[shopId]
      state.shops = shops
      if (state.currentShopId === shopId) {
        state.currentShopId = null
      }
    },
    SET_LOADING(state, loading) {
      state.isLoading = loading
    }
  },

  actions: {
    // 加载所有商铺
    async loadShops({ commit }) {
      commit('SET_LOADING', true)
      try {
        const shopConfigManager = (await import('../utils/shopConfig')).default
        const shops = shopConfigManager.getAllShops()
        commit('SET_SHOPS', shops)
        
        // 恢复当前商铺
        const currentShopId = shopConfigManager.getCurrentShopId()
        if (currentShopId && shops[currentShopId]) {
          commit('SET_CURRENT_SHOP', currentShopId)
        }
      } catch (error) {
        console.error('加载商铺失败:', error)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    // 创建商铺
    async createShop({ commit, dispatch }, { name, description }) {
      try {
        const shopConfigManager = (await import('../utils/shopConfig')).default
        const shopId = shopConfigManager.createShop(name, description)
        const config = shopConfigManager.getShopConfig(shopId)
        
        commit('ADD_SHOP', { shopId, config })
        return shopId
      } catch (error) {
        console.error('创建商铺失败:', error)
        throw error
      }
    },

    // 更新商铺配置
    async updateShop({ commit }, { shopId, config }) {
      try {
        const shopConfigManager = (await import('../utils/shopConfig')).default
        shopConfigManager.saveShopConfig(shopId, config)
        commit('UPDATE_SHOP', { shopId, config })
      } catch (error) {
        console.error('更新商铺失败:', error)
        throw error
      }
    },

    // 删除商铺
    async deleteShop({ commit }, shopId) {
      try {
        const shopConfigManager = (await import('../utils/shopConfig')).default
        shopConfigManager.deleteShop(shopId)
        commit('DELETE_SHOP', shopId)
      } catch (error) {
        console.error('删除商铺失败:', error)
        throw error
      }
    },

    // 切换当前商铺
    async switchShop({ commit }, shopId) {
      try {
        const shopConfigManager = (await import('../utils/shopConfig')).default
        shopConfigManager.applyTheme(shopId)
        commit('SET_CURRENT_SHOP', shopId)
      } catch (error) {
        console.error('切换商铺失败:', error)
        throw error
      }
    }
  },

  getters: {
    shopList: (state) => {
      return Object.keys(state.shops).map(shopId => ({
        id: shopId,
        ...state.shops[shopId]
      }))
    },
    currentShop: (state) => {
      if (!state.currentShopId) return null
      return state.shops[state.currentShopId] || null
    },
    shopCount: (state) => {
      return Object.keys(state.shops).length
    }
  }
}

export default shopStore

